module.exports = __webpack_public_path__ + "img/risk-arrow.0acdd152.svg";